import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import WordCloud from 'react-d3-cloud';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

export const WordCloudChart = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {

    const schemeCategory10ScaleOrdinal = scaleOrdinal(schemeCategory10);

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [loading, setLoading] = useState(false);

    const [widgetData, setwidgetData] = useState([]);

    const [hoverPop, setHoverPop] = useState({ show: false, target: null, word: null });

    const handleWordMouseOver = (event, word) => {
        const item = widgetData?.find((w) => w.text === word.text) || word;
        setHoverPop({ show: true, target: event.target, word: item });
    };

    const handleWordMouseOut = () => {
        setHoverPop({ show: false, target: null, word: null });
    };

    const wordCloudElement = useMemo(() => {
        if (!widgetData && widgetData?.length === 0) return null;
        return (
            <WordCloud
                data={widgetData}
                width={900}
                height={380}
                font="Segoe UI, Arial, sans-serif"
                fontWeight="bold"
                fontSize={(word) => {
                    const minVal = 1;
                    const maxVal = 100;
                    const minFont = 14;
                    const maxFont = 72;
                    const v = Math.max(minVal, Math.min(maxVal, Number(word.value) || minVal));
                    const size = minFont + ((v - minVal) / (maxVal - minVal)) * (maxFont - minFont);
                    return size ? size : minFont;
                }}
                spiral="rectangular"
                rotate={0}
                padding={4}
                fill={(word) => {
                    const item = widgetData?.find((w) => w.text === word.text) || word;
                    if (item.type === "positive") return "#1f8a2f";
                    if (item.type === "negative") return "#c62828";
                    return "#7a7a7a";
                }}
                onWordClick={(event, d) => {
                   
                }}
                onWordMouseOver={handleWordMouseOver}
                onWordMouseOut={handleWordMouseOut}
            />
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [widgetData]);

    const GetWidgetData = async () => {
        setLoading(true);

        try {
            let customday = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.ANALYTICS.WORLDCLOUDCHART,
                    body: {
                        "propertycode": para?.propertyCode,
                    },
                },
                false
            );

            let customdayresponse = apiResponse(false, customday);

            if (customdayresponse?.isValidate) {
            setwidgetData(customdayresponse.data?.data?.json_agg || [])
            }
            else {
                setwidgetData([]);
            }
        } catch (error) {
            console.error("Error fetching WordCloudChart data:", error);
            setwidgetData([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (api === 0) {

        } else {
            if (para?.asOfDate) {
                GetWidgetData();
            }
        }
    }, [para?.asOfDate]);


    return (
        <div className="widget-container">
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("WordCloudChart", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                if (widgetData?.length === 0) return
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "PerformanceADRMonitor",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("WordCloudChart", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                if (widgetData?.length === 0) return
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.WordCloudChart,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("WordCloudChart", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id1}
                            onClick={() => {
                                if (widgetData?.length === 0) return
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-PerformanceADRMonitor-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )}
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>

                {
                    loading ? (
                        <Loader />
                    )
                        :
                        (
                            <>
                                <div className="sentiment-word-cloud">
                                    <div className="swc-header">
                                        <div className="swc-legend">
                                            <span className="swc-legend-item">
                                                <span className="swc-dot swc-dot-positive"></span>
                                                Positive + Very Positive
                                            </span>
                                            <span className="swc-legend-item">
                                                <span className="swc-dot swc-dot-neutral"></span>
                                                Neutral / No Reviews
                                            </span>
                                            <span className="swc-legend-item">
                                                <span className="swc-dot swc-dot-negative"></span>
                                                Negative + Very Negative
                                            </span>
                                        </div>
                                    </div>
                                    <div className="swc-cloud-wrap">
                                        {wordCloudElement}
                                        <Overlay
                                            show={hoverPop.show && !!hoverPop.target}
                                            target={hoverPop.target}
                                            placement="bottom"
                                        >
                                            {(props) => {
                                                const w = hoverPop.word;
                                                const d = w?.details || {};
                                                const typeLabel =
                                                    w?.type === "positive" ? "Positive" :
                                                        w?.type === "negative" ? "Negative" : "Neutral";
                                                const rows = [
                                                    { label: "Very Positive", val: d["very positive"], cls: "swc-pop-positive" },
                                                    { label: "Positive", val: d["positive"], cls: "swc-pop-positive" },
                                                    { label: "Neutral", val: d["neutral"], cls: "swc-pop-neutral" },
                                                    { label: "Negative", val: d["negative"], cls: "swc-pop-negative" },
                                                    { label: "Very Negative", val: d["very negative"], cls: "swc-pop-negative" },
                                                ];
                                                return (
                                                    <Popover
                                                        id="swc-hover-popover"
                                                        {...props}
                                                        className={`swc-popover swc-popover-${w?.type || "neutral"}`}
                                                    >
                                                        <Popover.Header as="h3" className="swc-popover-title">
                                                            <span className="swc-pop-title-left">
                                                                <span className={`swc-dot swc-dot-${w?.type || "neutral"}`}></span>
                                                                {w?.text}
                                                            </span>
                                                            <span className={`swc-pop-badge swc-pop-badge-${w?.type || "neutral"}`}>
                                                                {typeLabel}
                                                            </span>
                                                        </Popover.Header>
                                                        <Popover.Body className="swc-popover-body">
                                                            <ul className="swc-pop-stats">
                                                                {rows.map((r) => (
                                                                    <li key={r.label}>
                                                                        <span className="swc-pop-stat-label">{r.label}</span>
                                                                        <span className={`swc-pop-stat-value ${r.cls}`}>{r.val ?? "0%"}</span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            <div className="swc-pop-summary-title">SUMMARY</div>
                                                            <div className="swc-pop-summary-text">
                                                                {d.summary || w?.summary || "No summary available."}
                                                            </div>
                                                        </Popover.Body>
                                                    </Popover>
                                                );
                                            }}
                                        </Overlay>
                                    </div>

                                    <div className="swc-summary">
                                        <div className="swc-card swc-card-positive">
                                            <div className="swc-card-header">
                                                <span className="swc-card-title">TOP POSITIVE THEMES</span>
                                            </div>
                                            <ul className="swc-card-list">
                                                {widgetData
                                                    ?.filter((w) => w.type === "positive")
                                                    ?.sort((a, b) => b.value - a.value)
                                                    ?.slice(0, 4)
                                                    ?.map((w) => (
                                                        <li key={w.text}>
                                                            <span className="swc-item-name">{w.text}</span>
                                                            <span className="swc-item-value">{w.value.toFixed(2)}%</span>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>

                                        <div className="swc-card swc-card-insights">
                                            <div className="swc-card-header">
                                                <span className="swc-card-title">KEY INSIGHTS</span>
                                            </div>
                                            <p className="swc-insight-text">
                                                {widgetData?.[0]?.summary}
                                            </p>
                                        </div>

                                        <div className="swc-card swc-card-negative">
                                            <div className="swc-card-header">
                                                <span className="swc-card-title">TOP NEGATIVE THEMES</span>
                                            </div>
                                            <ul className="swc-card-list">
                                                {widgetData
                                                    ?.filter((w) => w.type === "negative")
                                                    ?.sort((a, b) => b.value - a.value)
                                                    ?.slice(0, 4)
                                                    ?.map((w) => (
                                                        <li key={w.text}>
                                                            <span className="swc-item-name">{w.text}</span>
                                                            <span className="swc-item-value">{w.value.toFixed(2)}%</span>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                }


            </Row>
        </div>
    );
};

export default WordCloudChart;
